import { calcUpload } from '@/utils'
const columnsLifeStyle = [
  {
    title: '是否抽烟',
    dataIndex: 'smoke',
    key: 'smoke',
    width: 104,
    slots: { customRender: 'smoke' }
  },
  {
    title: '是否饮酒',
    dataIndex: 'drink',
    key: 'drink',
    width: 104,
    slots: { customRender: 'drink' }
  },
  {
    title: '运动习惯',
    dataIndex: 'sport',
    key: 'sport',
    width: 104,
    slots: { customRender: 'sport' }
  },
  {
    title: '睡眠时长',
    dataIndex: 'sleep',
    key: 'sleep',
    width: 104,
    slots: { customRender: 'sleep' }
  },
  {
    title: '上传人',
    dataIndex: 'changedName',
    key: 'changedName',
    width: 104
    // slots: { customRender: 'creatorName' }
  },
  {
    title: '上传时间',
    dataIndex: 'recordDate',
    key: 'recordDate',
    width: 104
  }
]
const columnsMedicalRecords = [
  {
    dataIndex: 'id',
    key: 'id',
    title: 'ID',
    width: 240,
    fixed: 'left'
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
    key: 'patientName',
    width: 180
  },
  {
    title: '就诊时间',
    dataIndex: 'inquiryTime',
    key: 'inquiryTime',
    width: 180,
    slots: { customRender: 'inquiryTime' }
  },
  // {
  //   title: '就诊医院',
  //   dataIndex: 'offlineHospital',
  //   key: 'offlineHospital',
  //   width: 180
  // },
  // {
  //   title: '就诊科室',
  //   dataIndex: 'offlineDepartment',
  //   key: 'offlineDepartment',
  //   width: 180
  // },
  // {
  //   title: '就诊医生',
  //   dataIndex: 'offlineDoctor',
  //   key: 'offlineDoctor',
  //   width: 180
  // },
  {
    title: '就诊诊断',
    dataIndex: 'offlineDiagnosis',
    key: 'offlineDiagnosis',
    width: 180,
    slots: { customRender: 'offlineDiagnosis' }
  },
  {
    title: '处方药品',
    dataIndex: 'medicationNames',
    key: 'medicationNames',
    width: 180,
    slots: { customRender: 'medicationNames' }
  },
  {
    title: '开始时间',
    dataIndex: 'beginTime',
    key: 'beginTime',
    width: 180,
    slots: { customRender: 'beginTime' }
  },
  {
    title: '用药周期',
    dataIndex: 'medicineCycle',
    key: 'medicineCycle',
    width: 180,
    slots: { customRender: 'medicineCycle' }
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    width: 180,
    slots: { customRender: 'endTime' }
  },

  // {
  //   title: '是否患者可见',
  //   dataIndex: 'patientPermission',
  //   key: 'patientPermission',
  //   width: 180,
  //   slots: { customRender: 'patientPermission' }
  // },
  {
    title: '上传人',
    dataIndex: 'createBy',
    key: 'createBy',
    width: 180,
    customRender: ({ record }) => {
      return calcUpload(record, 'createBy')
    }
  },
  {
    title: '上传时间',
    dataIndex: 'createAt',
    key: 'createAt',
    width: 180
  },

  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    slots: { customRender: 'handle' },
    fixed: 'right',
    width: 180
  }
]

const historyList = []
// 生活方式
const lifeList = [
  {
    id: 0,
    title: '是否吸烟',
    value: '',
    key: 'smoke',
    children: [
      {
        id: 1,
        name: '从不'
      },
      {
        id: 2,
        name: '偶尔'
      },
      {
        id: 3,
        name: '经常'
      },
      {
        id: 4,
        name: '已戒'
      }
    ]
  },
  {
    id: 1,
    title: '是否饮酒',
    value: '',
    key: 'drink',
    children: [
      {
        id: 1,
        name: '从不'
      },
      {
        id: 2,
        name: '偶尔'
      },
      {
        id: 3,
        name: '经常'
      },
      {
        id: 4,
        name: '已戒'
      }
    ]
  },
  {
    id: 2,
    title: '运动习惯',
    value: '',
    key: 'sport',
    children: [
      {
        id: 1,
        name: '不运动'
      },
      {
        id: 2,
        name: '1~3次'
      },
      {
        id: 3,
        name: '4~7次'
      },
      {
        id: 4,
        name: '>7次'
      }
    ]
  },
  {
    id: 3,
    title: '睡眠时长',
    value: '',
    key: 'sleep',
    children: [
      {
        id: 1,
        name: '<3小时'
      },
      {
        id: 2,
        name: '3～6小时'
      },
      {
        id: 3,
        name: '6～8小时'
      },
      {
        id: 4,
        name: '>8小时'
      }
    ]
  }
]
// 检查表单
const columnsExamine = [
  {
    title: '检查单ID',
    dataIndex: 'checklistId',
    key: 'checklistId',
    fixed: 'left',
    width: 120,
    slots: { customRender: 'checklistId' }
  },
  {
    title: '随访计划ID',
    dataIndex: 'adPlanId',
    key: 'adPlanId',
    slots: { customRender: 'adPlanId' },
    width: 120
  },
  // {
  //   title: '表单状态',
  //   dataIndex: 'formStatusString',
  //   key: 'formStatusString',
  //   width: 100
  // },
  {
    title: '推送时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 135
  },

  {
    title: '上传时间',
    dataIndex: 'uploadTime',
    key: 'uploadTime',
    width: 135
  },

  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    fixed: 'right',
    width: 120,
    slots: { customRender: 'handle' }
  }
]
export { columnsLifeStyle, historyList, lifeList, columnsMedicalRecords, columnsExamine }
